import _ from "lodash";
import {httpClient} from "@/Repositories/HttpClient";
import {GetIdFromObject} from "@/Repositories/helpers";

export const DEFAULT_FILE_KEY = 'file';

export default {
    async upload(file, values) {
        values = values || {
            file_key: DEFAULT_FILE_KEY,
        };

        let formData = new FormData;
        formData.append(values.file_key || DEFAULT_FILE_KEY, file);

        _.forEach(values, (value, name) => formData.append(name, value));

        return httpClient.post(route('files.upload'), formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    async delete(file) {
        const url = route('files.delete', {
            file: GetIdFromObject(file),
        });

        return httpClient.delete(url, file);
    }
}
